<template>
    <div class="cover-content table-wrapper">
      <!-- <high-search> -->
      <Form
        ref="formInline"
        :model="formInline"
        inline
        class="form-list"
        :label-width="100"
        label-position="right"
      >
        <Row :gutter="16">
          <Col span="6">
            <FormItem label="项目名称:">
              <Input
                v-model="formInline.projectName"
                placeholder="请输入项目名称"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="项目编号:">
              <Input
                v-model="formInline.projectCode"
                placeholder="请输入项目编号"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="项目类型:">
              <Select
                v-model="formInline.category"
                placeholder="请选择项目类型"
                filterable
              >
                <Option value="01">房屋建筑工程</Option>
                <Option value="02">市政公用工程</Option>
                <Option value="99">其他</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6" class="high-search">
            <FormItem :label-width="0">
              <Button type="primary" @click="handleQuery">搜索</Button>
              <Button style="margin-left: 20px" @click="handleReset">重置</Button>
              <span
                :class="open ? 'search-open' : 'search-close'"
                @click="open = !open"
                >{{ open ? "收起" : "展开" }}
                <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'"
              /></span>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16" v-show="open">
          <!-- <Col span="6">
            <FormItem label="项目状态:">
              <Select
                v-model="formInline.prjStatus"
                placeholder="请选择项目状态"
                filterable
              >
                <Option value="001">筹备</Option>
                <Option value="002">立项</Option>
                <Option value="003">在建</Option>
                <Option value="004">完工</Option>
                <Option value="005">停工</Option>
              </Select>
            </FormItem>
          </Col> -->
          <Col span="6">
            <FormItem label="考勤时间:" class="contentDate">
              <!-- <Tooltip
                placement="right"
                theme="light"
                transfer
                max-width="initial"
              >
                <span><Icon type="ios-help-circle-outline"/></span>
                <ul slot="content">
                  <li>
                    注:考勤时间段选择查询之后,若项目在该段时间范围内无考勤记录,
                  </li>
                  <li>则显示选择时间范围内最近考勤日期无考勤数据,</li>
                  <li>
                    若项目在该段时间范围内有考勤记录,则显示选择时间范围内最近考勤日期考勤数据
                  </li>
                </ul>
              </Tooltip> -->
              <!-- <template>
                              <el-date-picker
                                  class="marL"
                                  v-model="formInline.startDate"
                                  type="date"
                                  :picker-options="pickerOptions"
                                  placeholder="请选择一天" @change="timeChange"
                                  >
                              </el-date-picker>
                          </template> -->
              <!-- <DatePicker
                type="date"
                placeholder="请选择考勤开始时间"
                v-model="formInline.startDate"
                style="width: calc(50% - 6px);margin-right: 12px;"
                @on-change="handleStartDate"
                :options="{
                  disabledDate: disabledDateStart,
                }"
              ></DatePicker>
              <DatePicker
                type="date"
                placeholder="请选择考勤结束时间"
                v-model="formInline.endDate"
                style="width: calc(50% - 6px);"
                @on-change="handleEndDate"
                :options="{
                  disabledDate: disabledDateEnd,
                }"
              ></DatePicker> -->
              <!-- <el-date-picker
                type="date"
                class="marL"
                placeholder="请选择考勤时间"
                v-model="formInline.startDate"
                @change="handleStartDate"
                :picker-options="pickerOptions"
              ></el-date-picker> -->
              <DatePicker 
                    class="marL"
                    type="date"
                    :options="pickerOptions"
                    :value="formInline.startDate"
                    placeholder="请选择考勤时间"
                    @on-change="handleStartDate"/>
            </FormItem>
          </Col>
          <Col span="6">
            <!-- <FormItem label="是否考勤:">
              <Select
                v-model="formInline.isKq"
                placeholder="请选择是否考勤"
                filterable
              >
                <Option value="是">是</Option>
                <Option value="否">否</Option>
              </Select>
            </FormItem> -->
            <FormItem v-if="locationDisplay == 1" label="项目所在地:">
              <!-- <place-select v-model="formInline.areaCode"></place-select> -->
              <Cascader v-model="areaCode" :data="counties" @on-change="handleChange" clearable placeholder="请选择地区" change-on-select></Cascader>
              <!-- <Select v-model="formInline.areaCode" filterable transfer placeholder="请选择地区">
                              <Option v-for="(item,index) in area" :value="item.value" :key="index">{{ item.label }}</Option>
                          </Select> -->
            </FormItem>
            <FormItem v-else label="项目所在地:">
              <Input v-model="areaName" disabled></Input>
            </FormItem>
            
          </Col>
          <Col span="6">
            <FormItem label="项目经理是否考勤:">
              <Select
                v-model="formInline.managerAttendance"
                placeholder="请选择是否考勤"
                filterable
              >
                <Option :value="-1">全部</Option>
                <Option :value="1">是</Option>
                <Option :value="0">否</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="总监理工程师是否考勤:">
              <Select
                v-model="formInline.chiefInspectorAttendance"
                placeholder="请选择是否考勤"
                filterable
              >            
                <Option :value="-1">全部</Option>
                <Option :value="1">是</Option>
                <Option :value="0">否</Option>
              </Select>
            </FormItem>
            <!-- <FormItem label="管理人员类型:">
              <Select
                v-model="formInline.manageType"
                filterable
                transfer
                placeholder="请选择地区"
              >
                <Option
                  v-for="(item, index) in manageTypeArr"
                  :value="item.value"
                  :key="index"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem> -->
            
          </Col>
        </Row>
  
        <Row style="margin-bottom:24px;">
          <Col span="8">
            <Button icon="ios-exit-outline" type="primary" @click="handleExport"
              >导出</Button
            >
            <Tooltip style="margin-left: 15px;" placement="right" theme="light" transfer max-width="initial">
              <span><Icon size="16" type="ios-help-circle-outline"/></span>
              <ul slot="content">
                <!-- <li>注：1.系统支持查询截止2小时之前的考勤数据情况。</li> -->
                <li>1.平台支持查询前一天的到岗率情况，当天的到岗率情况需在第二天凌晨3点之后方可查询。</li>
              </ul>
            </Tooltip>
          </Col>
        </Row>
      </Form>
      <!-- </high-search> -->
      <div class="cover-table">
        <Table
          border
          style="width: 100%;"
          :loading="loading"
          :columns="tableColumn"
          :data="tableData"
          highlight-row
          @on-sort-change="sortableNum"
          @on-cell-click ="cellClick"
        >
          <template slot-scope="{ row, index }" slot="action">
            <span
              class="pointer"
              @click="handleDeal('projectDetail', row, row.projectCode)"
              >详情</span
            >
          </template>
        </Table>
        <Page
          class="page"
          :total="totalCount"
          :page-size="pageSize"
          :current="page"
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
          show-elevator
          show-sizer
          show-total
          transfer
        >
        </Page>
      </div>
      <!-- 弹窗 -->
      <Modal
         v-model="tableModal"
         width=80%
         :title="titleModal"
        >
          <div>
            <Form
              style="margin-top: 20px"
              ref="formInlineTable"
              :model="formInlineTable"
              inline
              class="form-list"
              :label-width="100"
              label-position="right"
            >
              <Row :gutter="24">
                <Col span="6">
                  <FormItem label="姓名:" :label-width="78">
                    <Input
                            v-model="formInlineTable.workerName"
                            placeholder="请输入姓名"
                            clearable
                    ></Input>
                  </FormItem>
                </Col>
  
                <Col span="6">
                  <FormItem label="参建单位:" :label-width="78">
                    <Input
                            v-model="formInlineTable.corpName"
                            placeholder="请输入参建单位"
                            clearable
                    ></Input>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem label="参建班组:" :label-width="78">
                    <Input
                            v-model="formInlineTable.teamName"
                            placeholder="请输入参建班组"
                            clearable
                    ></Input>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem label="工种:" :label-width="78">
                    <Select v-model="formInlineTable.workType" placeholder="选择工种" clearable>
                      <Option v-for="item in workTypeArr" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                    <!-- <Input
                      v-model="formInlineTable.workType"
                      placeholder="请选择工种"
                        clearable
                    ></Input> -->
                  </FormItem>
                </Col>
              </Row>
              <Row  :gutter="24">
                <Col span="6">
                  <FormItem label="人员状态:" prop="workerStatus" :label-width="78">
                    <RadioGroup v-model="formInlineTable.workerStatus">
                      <!-- <Radio :label="-1">全部</Radio> -->
                      <Radio :label="1">在场</Radio>
                      <Radio :label="0">在册</Radio>
                    </RadioGroup>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem label="人员类型:" prop="workRole" :label-width="78">
                    <RadioGroup v-model="formInlineTable.workRole">
                      <Radio :label="-1">全部</Radio>
                      <Radio :label="10">管理人员</Radio>
                      <Radio :label="20">建筑人员</Radio>
                    </RadioGroup>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem label="是否考勤:" prop="isAttendance" :label-width="78">
                    <RadioGroup v-model="formInlineTable.isAttendance">
                      <Radio :label="-1">全部</Radio>
                      <Radio :label="1">是</Radio>
                      <Radio :label="0">否</Radio>
                    </RadioGroup>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem label="考勤日期:">
                    <DatePicker
                      type="date"
                      placeholder="请选择考勤日期"
                      v-model="formInlineTable.workDate"
                      style="width: calc(100% - 12px)"
                      @on-change="handleStartDateTable"
                      :options="{
                      disabledDate: disabledDateStartTable,
                      }"
                      clearable
                    ></DatePicker>
                  </FormItem>
                </Col>
              </Row>
              <Row >
                <Col :span="24" style="margin-left:auto;text-align:right;">
                  <Button @click="handleSerach" type="primary">搜索</Button>
                </Col>
  
              </Row>
            </Form>
            <!-- </high-search> -->
            <div class="cover-table" style="margin-top:10px;">
              <Table
                 border
                 style="width: 100%"
                 :loading="loadingTable"
                 :columns="tableColumns"
                 :data="tableDatas"
                 highlight-row
                >
                <template slot-scope="{ row, index }" slot="isAttendances">
                  <span>{{isAttendanceConfig[row.isAttendance]}}    {{row.workTime}}</span>
                  <!-- <span>0000000</span> -->
                </template>
              </Table>
              <!-- @on-page-size-change="pageSizeChangeTable" -->
              <!-- show-sizer -->
              <Page
                class="page"
                :total="totalCountTable"
                :page-size="pageSizeTable"
                :current="pageTable"
                @on-change="changePageTablle"
                show-elevator
                show-total
                transfer
              >
              </Page>
            </div>
          </div>
        </Modal>
    </div>
  </template>
  <style scoped></style>
  <script>
  import { mapState } from "vuex";
  import tableMixin from "@/components/tableMixin";
  import { format } from "../../../utils/forMat";
  // import dataTime from "@/components/dataTimeMixinTwo";
  
  export default {
    mixins: [tableMixin],
    data() {
      return {
        pickerOptions: {
                      disabledDate(time) {
                          // 不能选择明天以后
                          const more = time.getTime() > Date.now()- 24 * 60 * 60 * 1000;
                          // const more = time.getTime() > Date.now()
                          // 不能选择90天之前
                          // const less = time.getTime() < (Date.now() - 86400000 * 90);
                          // 不能选择 2022-01-01之前
                          const less = time.getTime() < (new Date('2022-01-01').getTime() - 86400000);
                          return more || less;
                      },
                  },
        open: false,
          // areaCode: this.common.getTenantAreaCode(this.$route.query.areaCode),
          areaCode:[],
          counties:[],
        formInline: {
          areaCode: this.$route.query.areaCode, // 地区
          current: 1,
          endDate: "", // 结束时间
          projectName: "", // 项目名称
          size: 10,
          startDate: "", // 开始时间
          projectCode: "", // 项目编号
          category: "", // 类型
          prjStatus: "", // 项目状态
          // isKq: "", // 是否考勤:是,否
          managerAttendance:"", //项目经理是否考勤
          chiefInspectorAttendance:"", //总监理工程师是否考勤
          // manageType: "",
        },
        //管理人员类型数组
        manageTypeArr: [],
        tableColumn: [
          {
            title: "序号",
            type: "index",
            width: 70,
            fixed: "left",
            align: "center",
          },
          { title: "项目名称", key: "name", minWidth: 120, tooltip: true, align: "left" },
          { title: "项目编号", key: "projectCode", minWidth: 120, tooltip: true, align: "left" },
          { title: "项目类型", key: "category", minWidth: 100, tooltip: true, align: "left" },
          { title: "项目属地", key: "areaName", minWidth: 120, tooltip: true, align: "left" },
          { title: "项目状态", key: "prjStatus", minWidth: 100, align: "left" },
          { title: "考勤日期", key: "workDate", minWidth: 120, tooltip: true, align: "left" },
          {
            title: "总承包企业",
            key: "contractorCorpName",
            minWidth: 120,
            tooltip: true,
            align: "left"
          },
  
          {
            title: "在岗人数",
            key: "personNum",
            align: "left",
            minWidth: 120,
            sortable: "custom",
            render:(h,params) => {
              return h('div',[
                h('div',{
                  style:{
                     color: "#1890ff",
                     cursor: 'pointer'
                  }
                },params.row.personNum)
              ])
            },
            renderHeader: (h, params) => {
              return h("div", [
                h("span", "在岗人数"),
                h(
                  "Tooltip",
                  {
                    props: {
                      placement: "right",
                      theme: "light",
                      transfer: true,
                      content:
                        "指负责该项目的管理人员总数(不包含原负责项目管理且已退场的管理人员);",
                    },
                  },
                  [
                    h("Icon", {
                      props: {
                        type: "ios-help-circle-outline",
                      }
                    }),
                  ],
                ),
              ]);
            },
          },
          {
            title: "出勤人数",
            key: "attendanceNum",
            align: "left",
            minWidth: 140,
            sortable: "custom",
            render:(h,params) => {
              return h('div',[
                h('div',{
                  style:{
                     cursor: 'pointer'
                  }
                },params.row.attendanceNum)
              ])
            },
            renderHeader: (h, params) => {
              return h("div", [
                h("span", "出勤人数"),
                h(
                  "Tooltip",
                  {
                    props: {
                      placement: "right",
                      theme: "light",
                      transfer: true,
                      content: "指负责该项目的当日管理人员出勤总人数;",
                    },
                  },
                  [
                    h("Icon", {
                      props: {
                        type: "ios-help-circle-outline",
                      },
                    }),
                  ]
                ),
              ]);
            },
          },
          {
            title: "综合到岗率",
            key: "attendanceRate",
            align: "left",
            minWidth: 140,
            sortable: "custom",
            renderHeader: (h, params) => {
              return h("div", [
                h("span", "综合到岗率"),
                h(
                  "Tooltip",
                  {
                    props: {
                      placement: "right",
                      theme: "light",
                      transfer: true,
                      content:
                        "指当日该项目施工总承包单位、监理单位、其他单位管理人员出勤总人数/该项目施工总承包单位、监理单位、其他单位管理人员在场总人数;",
                    },
                  },
                  [
                    h("Icon", {
                      props: {
                        type: "ios-help-circle-outline",
                      },
                    }),
                  ]
                ),
              ]);
            },
          },
  
          {
            title: "施工总承包单位",
            key: "",
            minWidth: 120,
            tooltip: true,
            align: "left",
            children: [
              {
                title: "在岗人数",
                key: "contractorPersonNum",
                minWidth: 140,
                tooltip: true,
                sortable: "custom",
                render:(h,params) => {
                  return h('div',[
                    h('div',{
                      style:{
                         cursor: 'pointer'
                      }
                    },params.row.contractorPersonNum)
                  ])
                },
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "在岗人数"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "指施工总承包单位负责该项目的管理人员总数(不包含原负责项目管理且已退场的管理人员);",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
              {
                title: "出勤人数",
                key: "contractorAttendanceNum",
                align: "left",
                minWidth: 140,
                sortable: "custom",
                render:(h,params) => {
                  return h('div',[
                    h('div',{
                      style:{
                         cursor: 'pointer'
                      }
                    },params.row.contractorAttendanceNum)
                  ])
                },
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "出勤人数"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "指施工总承包单位负责该项目的当日管理人员出勤总人数;",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
              {
                title: "到岗率",
                key: "contractorAttendanceRate",
                align: "left",
                minWidth: 100,
                sortable: "custom",
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "到岗率"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "指当日该项目施工总承包单位的管理人员出勤总人数/该项目施工总承包单位管理人员在场总人数;",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
              {
                title: "项目经理到岗率",
                key: "managerAttendanceRate",
                align: "left",
                minWidth: 160,
                sortable: "custom",
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "项目经理到岗率"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "指当日有效项目经理出勤总人数/项目经理在场总人数(未设置该岗位的在建项目默认项目经理在场人员总数为1);",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
            ],
          },
          {
            title: "监理单位",
            key: "buildCorpName",
            minWidth: 210,
            tooltip: true,
            align: "left",
            children: [
              {
                title: "在岗人数",
                key: "supervisingPersonNum",
                minWidth: 140,
                tooltip: true,
                sortable: "custom",
                render:(h,params) => {
                  return h('div',[
                    h('div',{
                      style:{
                         cursor: 'pointer'
                      }
                    },params.row.supervisingPersonNum)
                  ])
                },
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "在岗人数"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "指监理单位负责该项目的管理人员总数(不包含原负责项目管理且已退场的管理人员);",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
              {
                title: "出勤人数",
                key: "supervisingAttendanceNum",
                align: "left",
                minWidth: 140,
                sortable: "custom",
                render:(h,params) => {
                  return h('div',[
                    h('div',{
                      style:{
                         cursor: 'pointer'
                      }
                    },params.row.supervisingAttendanceNum)
                  ])
                },
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "出勤人数"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "指监理单位负责该项目的当日管理人员出勤总人数;",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
              {
                title: "到岗率",
                key: "supervisingAttendanceRate",
                align: "left",
                minWidth: 120,
                sortable: "custom",
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "到岗率"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "指当日该项目监理单位的管理人员出勤总人数/该项目监理单位的管理人员在场总人数;",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
              {
                title: "总监理工程师到岗率",
                key: "chiefInspectorAttendanceRate",
                align: "left",
                minWidth: 180,
                sortable: "custom",
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "总监理工程师到岗率"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "指当日有效总监理工程师出勤总人数/总监理工程师在场总人数(未设置该岗位的在建项目默认总监理工程师(注册监理工程师)在场人员总数为1);",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
            ],
          },
          {
            title: "其它单位",
            key: "buildCorpName",
            minWidth: 210,
            tooltip: true,
            align: "left",
            children: [
              {
                title: "在岗人数",
                key: "otherPersonNum",
                minWidth: 140,
                tooltip: true,
                sortable: "custom",
                render:(h,params) => {
                  return h('div',[
                    h('div',{
                      style:{
                         cursor: 'pointer'
                      }
                    },params.row.otherPersonNum)
                  ])
                },
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "在岗人数"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "指其他单位负责该项目的管理人员总数(不包含原负责项目管理且已退场的管理人员);",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
              {
                title: "出勤人数",
                key: "otherAttendanceNum",
                align: "left",
                minWidth: 140,
                sortable: "custom",
                render:(h,params) => {
                  return h('div',[
                    h('div',{
                      style:{
                         cursor: 'pointer'
                      }
                    },params.row.otherAttendanceNum)
                  ])
                },
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "出勤人数"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "指其他单位负责该项目的当日管理人员出勤总人数;",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
  
              {
                title: "到岗率",
                key: "otherAttendanceRate",
                align: "left",
                minWidth: 120,
                sortable: "custom",
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "到岗率"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "指当日该项目其他单位的管理人员出勤总人数/该项目其他单位的管理人员在场总人数(其他单位是指除施工总承包单位、监理单位、建设单位以外的参建单位);",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
            ],
          },
          {
            title: "建设单位",
            key: "buildCorpName",
            minWidth: 210,
            tooltip: true,
            align: "left",
            children: [
              {
                title: "在岗人数",
                key: "buildPersonNum",
                minWidth: 140,
                tooltip: true,
                sortable: "custom",
                render:(h,params) => {
                  return h('div',[
                    h('div',{
                      style:{
                         cursor: 'pointer'
                      }
                    },params.row.buildPersonNum)
                  ])
                },
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "在岗人数"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "指建设单位负责该项目的管理人员总数(不包含原负责项目管理且已退场的管理人员);",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
              {
                title: "出勤人数",
                key: "buildAttendanceNum",
                align: "left",
                minWidth: 140,
                sortable: "custom",
                render:(h,params) => {
                  return h('div',[
                    h('div',{
                      style:{
                         cursor: 'pointer'
                      }
                    },params.row.buildAttendanceNum)
                  ])
                },
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "出勤人数"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "指建设单位负责该项目的当日管理人员出勤总人数;",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
              {
                title: "到岗率",
                key: "buildAttendanceRate",
                align: "left",
                minWidth: 120,
                sortable: "custom",
                renderHeader: (h, params) => {
                  return h("div", [
                    h("span", "到岗率"),
                    h(
                      "Tooltip",
                      {
                        props: {
                          placement: "right",
                          theme: "light",
                          transfer: true,
                          content:
                            "当日该项目建设单位管理人员出勤总人数/该项目建设单位管理人员在场总人数(仅进行数据展示，不计入综合到岗率的统计)。",
                        },
                      },
                      [
                        h("Icon", {
                          props: {
                            type: "ios-help-circle-outline",
                          },
                        }),
                      ]
                    ),
                  ]);
                },
              },
            ],
          },
          // { title: '参建班组', key: 'teamName', minWidth: 210, tooltip: true },
  
          // { title: '考勤日期', key: 'workDate', minWidth: 120 },
          // { title: '考勤人数', key: 'attendanceNum', align:'right', minWidth:100 },
          // { title: '出勤率', key: 'attendanceRate', align:'right', minWidth: 100 },
          {
            title: "操作",
            slot: "action",
            fixed: "right",
            align: "center",
            minWidth: 100,
          },
        ],
        tableData: [],
        areaName: this.$route.query.areaName,
  
        // ======================
        locationDisplay:'',
        projectId:'',
        titleModal:'',
        tableModal:false,// 改
        loadingTable:false, 
        tableDatas:[],
        totalCountTable:0,
  
        formInlineTable:{
          workerName:'',
          corpName:'',
          teamName:'管理人员班组',
          workerStatus:0,
          workRole:-1,
          workType:null,
          workDate :'',
          isAttendance:-1
        },
        workTypeArr:[],
        workerStatusObj:{
          '在场':1,
          '在册':0,
          // '到岗':1
        },
  
        workRoleObj:{
          '管理':10,
          '建筑':20
  
        },
        isAttendanceObj:{
          '出勤':1,
  
        },
        isAttendanceConfig:{
          1:'是',
          0:'否'
        },
        pageTable:1,
        pageSizeTable:10,
        tableColumns:[
            {
              title: '序号',
              type: 'index',
              width: 70,
              fixed: 'left',
              align: 'center',
            },
            { title: '姓名', key: 'workerName', minWidth: 100 },
            {
              title: '性别',
              key: 'gender',
              minWidth: 100,
  
            },
            { title: '参建单位', key: 'corpName', minWidth: 180, },
            { title: '参建班组', key: 'teamName', minWidth: 180, },
            { title: '工种', key: 'workType', minWidth: 180, },
  
            { title: '人员状态', key: 'workerStatus', minWidth: 100,  },
            { title: '人员类型', key: 'workRole', minWidth: 100,  },
            // { title: '项目经理', key: 'corpName', minWidth:120 },
            // { title: '项目总监', key: 'corpName', minWidth:120 },
            // { title: '项目负责人', key: 'corpName', minWidth:120 },
            { title: '考勤日期', key: 'workDate', minWidth: 120, },
            { title: '是否出勤', slot: 'isAttendances', minWidth: 120,  },
  
            {
              title: '本月出勤率',
              key: 'monthAttendanceRate',
              align: 'right',
              minWidth: 115,
            },
          ],
        // =============================
      };
    },
    computed: {
      ...mapState(["navList", "area", "citys", ]),
    },
    created() {
      this.formInline.areaCode = this.$route.query.areaCode;
      this.areaCode.push(this.$route.query.areaCode)
      this.locationDisplay = this.$route.query.locationDisplay;
      console.log(this.formInline.areaCode,'===========');
      
      this.formInline.startDate = this.$route.query.startDate;
      this.formInline.endDate = this.$route.query.startDate;
        this.getWorkTypeData();
        this.getCounties()
    },
    mounted() {
      //获取工程师类型
      // this.$nextTick(() => {
      //   this.getMerageType();
      // });
    },
    watch: {},
    methods: {
       // 项目详细地址
              getCounties() {
                  this.axios({
                      method: 'get',
                      url:`/dict/counties?areaCode=${this.formInline.areaCode}`,
                      }).then( (res)=> {
                          this.counties = res.data.data
                  })
              },
              handleChange(data, selectedData ){
                  const sd = selectedData[selectedData.length-1] || {};
                  this.formInline.areaCode = sd.value
              },
      timeChange(val) {
        this.formInline.startDate = format(val, "yyyy-MM-dd");
        this.formInline.endDate = format(val, "yyyy-MM-dd");
      },
      disabledDateStart(val) {
        return (
          new Date(this.formInline["endDate"] || "").getTime() < val.getTime()
        );
      },
      disabledDateEnd(val) {
        return (
          new Date(this.formInline["startDate"] || "").getTime() -
            24 * 60 * 60 * 1000 >
          val.getTime()
        );
      },
      handleStartDate(val) {
        this.formInline["startDate"] = format(val, "yyyy-MM-dd") || '';
        this.formInline["endDate"] = format(val, "yyyy-MM-dd") || '';
      },
      handleEndDate(val) {
        this.formInline["endDate"] = val;
      },
      handleReset() {
        this.pageSize = 10;
        this.page = 1;
        this.areaCode = []
        this.areaCode.push(this.$route.query.areaCode)
        this.formInline = {
          areaCode: this.$route.query.areaCode, // 地区
          current: 1,
          endDate: "", // 结束时间
          projectName: "", // 项目名称
          size: 10,
          startDate: "", // 开始时间
          projectCode: "", // 项目编号
          category: "", // 类型
          prjStatus: "", // 项目状态
          // isKq: "", // 是否考勤:是,否
          managerAttendance:'',
          chiefInspectorAttendance:'',
          // manageType: "", //管理人员类型
        };
        this.getTableData();
      },
      //导出
      handleExport() {
        const {
          startDate,
          endDate,
          projectName,
          workerName,
          corpName,
          areaCode,
          projectCode,
          category,
          prjStatus,
          // isKq,
          managerAttendance,
          chiefInspectorAttendance,
          // manageType,
        } = this.formInline;
        this.axios({
          method: "post",
          url: "/worker/sx/projectCorpManage/export",
          responseType: "arraybuffer",
          data: {
              startDate: startDate || '',
              endDate: endDate || '',
            projectName,
            workerName,
            corpName,
            areaCode,
            // manageType,
            size: this.pageSize,
            current: this.page,
            projectCode,
            category,
            prjStatus,
            // isKq,
            managerAttendance,
          chiefInspectorAttendance,
          },
        }).then((response) => {
          this.common.download(
            response,
            "管理人员到岗统计.xls",
            "application/vnd.ms-excel"
          );
        });
      },
      // 排序
      sortableNum(column, key, order) {
        console.log(column, key, order,'---------------');
        this.getTableData(column.key, column.order);
      },
      /*处理操作*/
      handleDeal(name, row, id) {
        this.$router.push({
          name: name,
          query: {
            projectId: id,
          },
        });
      },
      //获取工程师类型得数据
      getMerageType() {
        this.axios({
          method: "get",
          url: "/worker/sx/allManage/type",
        }).then((res) => {
          console.log(res.data);
          if (res.data.success) {
            this.manageTypeArr = res.data.data.map((item) => {
              return {
                value: item.code,
                label: item.name,
              };
            });
          }
        });
      },
      /*获取表格数据*/
      getTableData(val = "", type = "") {
        const {
          startDate,
          endDate,
          projectName,
          workerName,
          corpName,
          areaCode,
          projectCode,
          category,
          prjStatus,
          // isKq,
          managerAttendance,
          chiefInspectorAttendance,
          // manageType,
        } = this.formInline;
        this.loading = true;
        this.axios({
          method: "post",
          url: "/worker/sx/corpManage/projects",
          data: {
            startDate: startDate || '',
            endDate: endDate || '',
            projectName,
            workerName,
            corpName,
            areaCode: areaCode,
            size: this.pageSize,
            // manageType,
            current: this.page,
            projectCode,
            category,
            prjStatus,
            // isKq,
            managerAttendance,
            chiefInspectorAttendance,
            sortType: type.toUpperCase(),
            sortKind: val,
          },
        })
          .then((response) => {
            this.loading = false;
            if (response.data.success) {
              this.totalCount = response.data.data.total;
              this.tableData = response.data.data.records;
              // console.log("sss", response.data, this.tableData);
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },
      // =============================
          //工种 类型
      async getWorkTypeData(){
        let res = await this.axios({
          method: 'get',
          url: '/dict/getDic?dicType=workerType',
        });
        if(res.data.data){
          this.workTypeArr = res.data.data.map((item)=>{
            return {
              value:item.code,
              label:item.name
            };
          });
        }
  
      },
      disabledDateStartTable(time){
        return new Date().getTime() < time.getTime();
      },
      handleStartDateTable(val) {
        console.log(val);
        this.formInlineTable['workDate'] = val;
      },
      //弹窗搜索
      handleSerach(){
        this.pageTable = 1;
        // console.log(this.formInlineTable.workerName,this.formInlineTable.corpName,this.formInlineTable.teamName,this.formInlineTable.workType,'搜索数据');
  
        // console.log(this.formInlineTable.workerStatus,this.formInlineTable.workRole,this.formInlineTable.isAttendance,format(this.formInlineTable.workDate, "yyyy-MM-dd"),'搜索数据');
        this.getTableModel();
      },
  
      //点击事件 每个单元格
      cellClick(row, column, cell, event){
        // this.tableModal = true;
        // console.log(row, column, cell, event,'点击事件 每个单元格');
        // this.tableModal = true;
            this.formInlineTable={
              workerName:'',
              corpName:'',
              teamName:'管理人员班组',
              workType:null,
            },
            this.pageTable = 1;
            this.titleModal = row.name
            this.formInlineTable.workDate = row.workDate;
            this.projectId = row.projectCode
            // this.projectId = "1413080234779404700"
            this.formInlineTable.workerStatus = 1
            this.formInlineTable.workRole = 10
            this.formInlineTable.isAttendance = -1
            
        if(column._index === 8 || column._index === 9 || column._index === 15 || 
           column._index === 16 || column._index === 19 || column._index === 20 || column._index === 22 || column._index === 23 ) {
            this.tableModal = true;
            this.getTableModel();
            // this.formInlineTable={
            //   workerName:'',
            //   corpName:'',
            //   teamName:'管理人员班组',
            //   workType:null,
            // },
            // this.pageTable = 1;
            // this.titleModal = row.name
            // this.formInlineTable.workDate = row.workDate;
            // // this.projectId = row.projectCode
            // this.projectId = "1413080234779404700"
            // this.formInlineTable.workerStatus = 1
            // this.formInlineTable.workRole = 10
            // this.formInlineTable.isAttendance = -1
            // // console.log(column,'=====点击事件参数2 column====区分点击的那个单元格=');
            // // console.log(row,'=====展示弹窗 参数1 row==一行的详细数据====');
            // this.getTableModel();
            // console.log(this.formInlineTable.workerStatus,'搜索数据');
            
        }else if(column._index === 11 || column._index === 12 ) {
          this.tableModal = true;
          this.formInlineTable.corpName = row.contractorCorpName
          this.getTableModel();
        }
        else {
          this.tableModal = false;
        }
  
      },
      // 获取弹窗列表数据
      getTableModel(){
        let params = Object.assign({},this.formInlineTable);
        params.workDate = format(new Date( params.workDate), 'yyyy-MM-dd'),
        params.projectId = this.projectId;
        params.pageNo  = this.pageTable;
        params.pageSize = this.pageSizeTable;
        this.loadingTable = true;
        this.axios({
          method: 'post',
          url: '/project/worker/queryProjectWorkerAttendanceList',
          data: params
        }).then((res)=>{
          this.loadingTable = false;
          if(res.data.data){
            // console.log(res,'===================================');
            this.totalCountTable = res.data.data.total;
            this.tableDatas = res.data.data.records;
          }
        });
      },
      // 弹窗列表
      changePageTablle(value) {
        this.pageTable = value;
        this.getTableModel();
      },
       ok () {
        // this.$Message.info('Clicked ok');
      },
      cancel () {
        // this.$Message.info('Clicked cancel');
      }
    },
  };
  </script>
  <style scoped>
  .ivu-tooltip-inner {
    max-width: initial;
  }
  .marL {
    width: 100%;
    height: 32px;
  }
  .marL >>> .el-input__inner {
    display: inline-block;
    height: 32px;
  }
  .marL >>> .el-icon-date {
    margin-left: -9px;
    font-size: 14px;
    /* margin-top:-8px; */
  
    color: #c0c4cc;
    float: left;
    line-height: 32px;
  }
  .marL >>> .el-range-separator {
    margin-top: -8px;
    display: inline-block;
    width: 16%;
  }
  .marL >>> .el-range__close-icon {
    margin-top: -8px;
  }
  .marL >>> .el-input__suffix .el-input__icon {
    height: 32px;
    line-height: 32px;
  }
  .contentDate >>> .ivu-date-picker {
    /* width: calc(45% - 0px) !important; */
  }
  .page {
    text-align: right !important;
  }
  </style>
  